/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material';

type MuiInputLabelComponent = {
  defaultProps?: ComponentsProps['MuiInputLabel'];
  styleOverrides?: ComponentsOverrides['MuiInputLabel'];
  variants?: ComponentsVariants['MuiInputLabel'];
};

export const InputLabelComponent: MuiInputLabelComponent = {
  styleOverrides: {
    shrink: {
      transform: 'translate(14px, -8px) scale(0.75) !important',
    },
    outlined: {
      transform: 'translate(14px, 13px) scale(1)',
    },
  },
};
